import React, { FC } from 'react';
import './Footer.scss';
import { Col, Container, Row } from 'react-bootstrap';
import { useStyle } from '../../providers/StyleProvider';
import bevi from '../../assets/img/Bevi.svg';
import selo from '../../assets/img/gptw-selo.svg';
import { BvIcon } from 'bevi-icon';

interface FooterProps {
  fixed?: boolean;
}

const Footer: FC<FooterProps> = ({ fixed }) => {
  const { style } = useStyle();

  return (
    <footer
      className={`footer Footer pt-1 ${fixed ? "fixed" : ""}`}
      data-testid="Footer"
    >
      <Container>
        <div className="content-imagens border-bottom">
          <div className="bevi mb-3">
            <img src={bevi} alt="Logo Bevi" className="img-responsive-bevi" />
          </div>
          <div className="selo mb-3">
            <img src={selo} alt="Logo Selo" className="img-responsive-selo" />
          </div>
        </div>
        <Row className="p-0 p-sm-4">
          <Col md={6} className="mb-lg-0 mb-4 text-start">
            <p className="text-location">
              <strong>Matriz (Presidente Prudente - SP):</strong> Av. Manoel
              Goulart, 300 - Vila Nova - CEP 19010-270 - 18 3916 9100
              <BvIcon
                name="place"
                values="solid"
                weight={600}
                width={16}
                height={16}
                className="ms-1"
              />
            </p>
          </Col>
          <Col md={6} className="mb-lg-0 mb-4 text-sm-center text-start">
            <p className="text-location">
              <strong>São Paulo - SP:</strong> Rua Alameda Santos, 700 - Jardim
              Paulista, Sala 101 - CEP 01418-100 - 11 3171 0117
              <BvIcon
                name="place"
                values="solid"
                weight={600}
                width={16}
                height={16}
                className="ms-1"
              />
            </p>
          </Col>
          <Col md={12} className="mb-lg-0 mb-4 mt-2 text-sm-center text-start ">
            <p className="text-location">
              Bevicred Informações Cadastrais Ltda - CNPJ: 07.452.085/0001-98 ©
              2025 Bevi - Todos os direitos reservados.
            </p>
          </Col>
          <Col md={12} className="mb-lg-0 mt-2 text-sm-center text-start">
            <a
              href="https://www.bevioficial.com.br/privacidade/politica-de-ciberseguranca?code=0"
              target="_blank"
              className="text-sm text-lg-end"
            >
              Termos de Uso e Política de Privacidade
            </a>
          </Col>
        </Row>
      </Container>
    </footer>
  );
}

export default Footer;
